import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PersonFormModel } from '@base/models/form/person-form.model';
import { Country } from '@base/backend';

@Component({
  selector: 'app-person-data',
  standalone: true,
  imports: [
    ReactiveFormsModule
  ],
  templateUrl: './person-data.component.html',
  styleUrl: './person-data.component.scss'
})
export class PersonDataComponent {

  @Input() formGroup!: FormGroup<PersonFormModel>;

  Country = Country;
}
